export class Response_1 {
  constructor(
    public cannotBeAssessed: boolean | false,
    public cannotBeAssessedReason: string | null,
    public metNotMetStatus: string | null,
    public surveillanceStaffs: Array<SurveillanceStaff>,
    public comments: string | null
  ) {
    this.cannotBeAssessed = cannotBeAssessed;
    this.cannotBeAssessedReason = cannotBeAssessedReason;
    this.metNotMetStatus = metNotMetStatus;
    this.surveillanceStaffs = surveillanceStaffs;
    this.comments = comments;
  }

  static init = () => new Response_1(false, null, null, [], null);
}

export class SurveillanceStaff {
  constructor(
    public staffRole: string | null,
    public nationalRequired: number | null,
    public nationalCurrentlyAvailable: number | null,
    public regionRequired: number | null,
    public regionCurrentlyAvailable: number | null,
    public subNationalRequired: number | null,
    public subNationalCurrentlyAvailable: number | null,
    public serviceDeliveryRequired: number | null,
    public serviceDeliveryCurrentlyAvailable: number | null,
    public communityRequired: number | null,
    public communityCurrentlyAvailable: number | null
  ) {
    this.staffRole = staffRole;
    this.nationalRequired = nationalRequired;
    this.nationalCurrentlyAvailable = nationalCurrentlyAvailable;
    this.regionRequired = regionRequired;
    this.regionCurrentlyAvailable = regionCurrentlyAvailable;
    this.subNationalRequired = subNationalRequired;
    this.subNationalCurrentlyAvailable = subNationalCurrentlyAvailable;
    this.serviceDeliveryRequired = serviceDeliveryRequired;
    this.serviceDeliveryCurrentlyAvailable = serviceDeliveryCurrentlyAvailable;
    this.communityRequired = communityRequired;
    this.communityCurrentlyAvailable = communityCurrentlyAvailable;
  }

  static init = () =>
    new SurveillanceStaff(null, null, null, null, null, null, null, null, null, null, null);
}
